export const CUSTOM = 'CUSTOM';
export const VENMO = 'VENMO';
export const PAYPAL = 'PAYPAL';
export const WHOLE_FOODS = 'WHOLE_FOODS';
export const AMAZON = 'AMAZON';
export const GAS_STATION = 'GAS_STATION';
export const GREEN_DOT = 'GREEN_DOT';
export const ATM = 'ATM';
export const UBER = 'UBER';
export const RESTAURANT = 'RESTAURANT';

export const VENDORS = [
  CUSTOM,
  VENMO,
  PAYPAL,
  WHOLE_FOODS,
  AMAZON,
  GAS_STATION,
  GREEN_DOT,
  ATM,
  UBER,
  RESTAURANT
];